/**
 * @generated SignedSource<<86264720f08b99e008e796c46d1a821b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_FiltersUI$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"authorFilter_softwareCodePage" | "repositoryFilter_softwareCodePage_RepositoriesFilter" | "reviewersFilter_softwareCodePage" | "statusFilter_softwareCodePage">;
  readonly " $fragmentType": "main_softwareCodePage_FiltersUI";
}>;
export type main_softwareCodePage_FiltersUI$key = ReadonlyArray<{
  readonly " $data"?: main_softwareCodePage_FiltersUI$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_FiltersUI">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "main_softwareCodePage_FiltersUI",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "repositoryFilter_softwareCodePage_RepositoriesFilter"
    },
    {
      "kind": "FragmentSpread",
      "name": "authorFilter_softwareCodePage"
    },
    {
      "kind": "FragmentSpread",
      "name": "reviewersFilter_softwareCodePage"
    },
    {
      "kind": "FragmentSpread",
      "name": "statusFilter_softwareCodePage"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "faa35e351aef7ec3e5621007a7cd27df";

export default node;
